module.exports = __webpack_public_path__ + "static/img/rank_10.c2d9899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_10.png
// module id = kwuW
// module chunks = 0